webpackJsonp([0],{

/***/ "+XD5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-game-cards"},[_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.cards,"alt":"Lucre Games GeoTap game screens, a relaxing casual game with lowpoly design"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Y5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page presskit-page"},[_c('router-link',{attrs:{"to":"/","data-gtm":"Presskit > Click","data-gtm-value":"GeoTap Logo"}},[_c('geotap-logo',{attrs:{"heading":"h1"}})],1),_c('h2',[_vm._v("Privacy Policy")]),_c('text-content',[_c('strong',[_vm._v("Overview:")]),_c('p',[_vm._v("Thank you for your interest in GeoTap by Lucre Games! Here's what you need to know about your data while using this software: GeoTap does not track identifying personal information, but we do use system and gameplay analytics to learn about how our users experience the game. We also save an anonymous user profile for each device running the game. This is used to track advertising and analytics events. Lucre Games does not share any user data it collects from GeoTap with outside parties, except implicilty with Unity Technologies and Google  and Apple platforms that distribute the software. The game is created with Unity software, which does its own tracking explained below.   ")]),_c('strong',[_vm._v("Software:")]),_c('p',[_vm._v("Unity has probably collected some or all of the following information about your device: unique device identifiers (e.g., IDFV for iOS devices and Android ID for Android devices) ); IP address; country of install (mapped from IP address); device manufacturer and model platform type (iOS, Android, Mac, Windows, etc.) and the operating system and version running on your system or device; language; CPU information such as model, the number of CPUs present, frequency, and instruction set support flags; the graphics card type and vendor name; graphics card driver name and version (example: \"nv4disp.dll 6.10.93.71\"); which graphics API is in use (example: \"OpenGL 2.1\" or \"Direct3D 9.0c\"); amount of system and video RAM present; current screen resolution; version of the Unity Editor used to create the  game; sensor flags (e.g., device support for gyroscope, touch pressure or accelerometer); application or bundle identification (\"app ID\") of the game installed; unique advertising identifiers provided for iOS and Android devices (e.g., IDFA or Android Ad ID); and a checksum of all the data that gets sent to verify that it did transmit correctly. ")]),_c('strong',[_vm._v("Analytics:")]),_c('p',[_vm._v("Unity has collected device information, like IP address and device identifiers, as well as events completed or actions taken within the game, including level, number of credits, time it took you to earn them, metadata about in-game communications and the value and details of purchases. Using our systems, the developer of the game has ongoing access to this data. Other Unity customers may have access to aggregated reports about game activity in general across a number of games. These reports are based, in part, on your game activities, but do not specifically identify you or your device. ")]),_c('strong',[_vm._v("Ads:")]),_c('p',[_vm._v("Unity Ads has probably collected device information, like IP address and device identifiers,and information regarding the delivery of ads and your interaction with them, all of which may be shared with ad publishers and attribution companies. Unity Ads may also incorporate data derived from the Unity Analytics service in user profiles and use that profile data in order to provide personalized advertising. When Unity provides personalized advertising, it will provide you notice and information about how to opt-out of such interest based advertising. ")]),_c('strong',[_vm._v("Game Services: ")]),_c('p',[_vm._v("GeoTap uses Google Play Games Services for Android devices and Game Center services for iOS devices to host leaderboards and achievements. You have the option to play GeoTap without these services, but the related features will not be accessible. GeoTap does not store any information about your account with these services. ")])]),_c('lucre-footer'),_c('div',{staticClass:"gradient-area"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/sw3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Dd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Marquee_vue__ = __webpack_require__("81Sa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52faeab3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Marquee_vue__ = __webpack_require__("s1s7");
function injectStyle (ssrContext) {
  __webpack_require__("/sw3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Marquee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52faeab3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Marquee_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2hiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeotapLogo_vue__ = __webpack_require__("sRCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c8fdffc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GeotapLogo_vue__ = __webpack_require__("DRzB");
function injectStyle (ssrContext) {
  __webpack_require__("acrx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeotapLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c8fdffc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GeotapLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Ar6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3h53":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7AQu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'laurels',
  data: function() {
    return {
      laurels: [__webpack_require__("RRR9"), __webpack_require__("kfK6"), __webpack_require__("r6Sm")]
    };
  }
});


/***/ }),

/***/ "81Sa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SpinningCube__ = __webpack_require__("O/Se");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StoreLinks__ = __webpack_require__("AOMC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GeotapLogo__ = __webpack_require__("2hiU");
var $;

$ = __webpack_require__("7t+N");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'marquee',
  data: function() {
    return {
      ready: false
    };
  },
  components: {
    'spinning-cube': __WEBPACK_IMPORTED_MODULE_0__components_SpinningCube__["a" /* default */],
    'store-links': __WEBPACK_IMPORTED_MODULE_1__components_StoreLinks__["a" /* default */],
    'geotap-logo': __WEBPACK_IMPORTED_MODULE_2__components_GeotapLogo__["a" /* default */]
  },
  beforeMount: function() {
    return setTimeout(this.buildin, 200);
  },
  methods: {
    
    // Scroll down to the next main section
    onDownArrowClick: function() {
      return $('html, body').animate({
        scrollTop: $(".lucre-laurels").offset().top - 50,
        easing: 'swing'
      }, 1600);
    },
    buildin: function() {
      this.ready = true;
      return console.log('build in', this.ready);
    }
  }
});


/***/ }),

/***/ "9oBU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AOMC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreLinks_vue__ = __webpack_require__("df1Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01071257_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_StoreLinks_vue__ = __webpack_require__("kFtB");
function injectStyle (ssrContext) {
  __webpack_require__("p8EQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01071257_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_StoreLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C+62":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lucre-games-google-play-icon.994e887.png";

/***/ }),

/***/ "DRzB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-geotap-logo"},[(_vm.heading == 'h1')?_c('h1',{staticClass:"heading"},[_vm._v("GEOTAP  ")]):_vm._e(),(_vm.heading == 'h4')?_c('h4',{staticClass:"heading"},[_vm._v("GEOTAP  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E0n6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameCards_vue__ = __webpack_require__("HTS3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_039a2b62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GameCards_vue__ = __webpack_require__("+XD5");
function injectStyle (ssrContext) {
  __webpack_require__("VUTr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_039a2b62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GameCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FGyt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GeotapLogo__ = __webpack_require__("2hiU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StoreLinks__ = __webpack_require__("AOMC");
var site;

site = __webpack_require__("PaZl");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lucre-footer',
  components: {
    'geotap-logo': __WEBPACK_IMPORTED_MODULE_0__components_GeotapLogo__["a" /* default */],
    'store-links': __WEBPACK_IMPORTED_MODULE_1__components_StoreLinks__["a" /* default */]
  },
  data: function() {
    return {
      socialLinks: site.social.links
    };
  }
});


/***/ }),

/***/ "FYcl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextContent_vue__ = __webpack_require__("NXJ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61ca639d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TextContent_vue__ = __webpack_require__("x4nf");
function injectStyle (ssrContext) {
  __webpack_require__("PBhd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61ca639d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TextContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FyeP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PressKit_vue__ = __webpack_require__("rC6c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08bb30c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PressKit_vue__ = __webpack_require__("wD4R");
function injectStyle (ssrContext) {
  __webpack_require__("g1j8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PressKit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08bb30c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PressKit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GuLX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialLinks_vue__ = __webpack_require__("hN/e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a4f9d5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SocialLinks_vue__ = __webpack_require__("fHJi");
function injectStyle (ssrContext) {
  __webpack_require__("j7wJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a4f9d5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SocialLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HTS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'game-cards',
  data: function() {
    return {
      cards: __webpack_require__("Pu3T")
    };
  }
});


/***/ }),

/***/ "HXef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Zhfs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3481be94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("aasZ");
function injectStyle (ssrContext) {
  __webpack_require__("3Ar6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3481be94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3481be94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KcPi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L2fN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Lh/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Laurels_vue__ = __webpack_require__("7AQu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdcf99aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Laurels_vue__ = __webpack_require__("nr35");
function injectStyle (ssrContext) {
  __webpack_require__("KcPi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Laurels_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdcf99aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Laurels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("OWjy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("cX1j");
function injectStyle (ssrContext) {
  __webpack_require__("9oBU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_styl__ = __webpack_require__("tLzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_visual__ = __webpack_require__("c3y4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_visual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_visual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_in_viewport_directive__ = __webpack_require__("VYcz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_in_viewport_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_in_viewport_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SocialLinks__ = __webpack_require__("GuLX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LucreLogo__ = __webpack_require__("W2iy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TextContent__ = __webpack_require__("FYcl");


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('visual', __WEBPACK_IMPORTED_MODULE_4_vue_visual___default.a).options.setDefaults({});


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('in-viewport', __WEBPACK_IMPORTED_MODULE_5_vue_in_viewport_directive___default.a);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('social-links', __WEBPACK_IMPORTED_MODULE_6__components_SocialLinks__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('lucre-logo', __WEBPACK_IMPORTED_MODULE_7__components_LucreLogo__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('text-content', __WEBPACK_IMPORTED_MODULE_8__components_TextContent__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NXJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'text-content',
  props: ['content']
});


/***/ }),

/***/ "Nb4G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-mobile-unlockable-low-poly-shapes.16ed5dd.png";

/***/ }),

/***/ "NpH0":
/***/ (function(module, exports, __webpack_require__) {

var description, ogDescr, ogImage, ogSiteName, ogTitle, ogTwitterDescr, ogTwitterImage, ogTwitterTitle, ogTwitterUrl, ogUrl, site, title;

site = __webpack_require__("PaZl");

title = document.querySelector("title");

ogImage = document.querySelector("meta[property='og:image']");

ogTwitterImage = document.querySelector("meta[property='twitter:image']");

ogTitle = document.querySelector("meta[property='og:title']");

ogTwitterTitle = document.querySelector("meta[property='twitter:title']");

ogUrl = document.querySelector("meta[property='og:url']");

ogTwitterUrl = document.querySelector("meta[property='twitter:url']");

description = document.querySelector("meta[name='description']");

ogDescr = document.querySelector("meta[property='og:description']");

ogTwitterDescr = document.querySelector("meta[property='twitter:description']");

ogSiteName = document.querySelector("meta[property='og:site_name']");

module.exports = {
  beforeMount: function() {
    if (!this.meta) {
      return;
    }
    if (this.meta.title) {
      title.text = this.meta.title;
    }
    if (this.meta.title) {
      ogTitle.content = this.meta.title;
    }
    if (this.meta.title) {
      ogTwitterTitle.content = this.meta.title;
    }
    if (this.meta.image) {
      ogImage.content = this.meta.image;
    }
    if (this.meta.image) {
      ogTwitterImage.content = this.meta.image;
    }
    if (this.meta.description) {
      description.content = this.meta.description;
    }
    if (this.meta.description) {
      ogDescr.content = this.meta.description;
    }
    if (this.meta.description) {
      ogTwitterDescr.content = this.meta.description;
    }
    ogUrl.content = site.page.url + this.meta.route;
    ogTwitterUrl.content = site.page.url + this.meta.route;
    if (this.meta.title) {
      return ogSiteName.content = this.meta.title;
    }
  }
};


/***/ }),

/***/ "O/Se":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningCube_vue__ = __webpack_require__("ztKq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_603ef5ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningCube_vue__ = __webpack_require__("XZAa");
function injectStyle (ssrContext) {
  __webpack_require__("3h53")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningCube_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_603ef5ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningCube_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OWjy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function() {
    return {
      ready: false
    };
  },
  mounted: function() {
    return setTimeout(this.makeReady, 200);
  },
  methods: {
    makeReady: function() {
      return this.ready = true;
    }
  }
});


/***/ }),

/***/ "PBhd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PaZl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {
  // Replace the image at this path with a 512x512 png
  favicon: "../src/assets/favicon.png",

  page: {
    title: "GeoTap Game | Relaxing Casual Mobile Game",
    description: "Page description",
    keywords: "Casual, Mobile Games, iOS Game, Android Game, Relaxing",
    url: "http://geotapgame.com",
  },
  
  game: {
    name: "New Game",
    description: "Game description",
    trailerUrl: "", 
    playStoreUrl: "https://www.geotapgame.com/android",
    appStoreUrl: "https://www.geotapgame.com/ios"
  },

  social: {
    image: "http://geotapgame.com/static/geotap-game-lucre-games-lowpoly-3d-casual-relaxing-mobile-game.png",
    links: [
      { icon: 'twitter', url: 'https://twitter.com/LucreGames/' },
      { icon: 'facebook', url: 'https://www.facebook.com/LucreGames/' },
    ]
  },
  
  schema: {
    genre: '["Casual", "3D",]',
  },

  gtmContainer: 'GTM-TTQ2KP3',

}


/***/ }),

/***/ "Pu3T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lucre-games-geotap-game-casual-relaxing-low=poly-design-game-cards.315cc89.png";

/***/ }),

/***/ "R+Vo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-5.bff8074.png";

/***/ }),

/***/ "RRR9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-indie-corner-feature.58be8b0.png";

/***/ }),

/***/ "TOHJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-4.9c45791.png";

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("FGyt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d722cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("jMLb");
function injectStyle (ssrContext) {
  __webpack_require__("qSkX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d722cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UIE5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-reviews"},[_c('div',{staticClass:"review-list"},_vm._l((_vm.reviews),function(review){return _c('div',{key:review.title,staticClass:"review"},[_c('h4',{domProps:{"innerHTML":_vm._s(review.title)}}),_c('div',{staticClass:"stars"},_vm._l((review.stars),function(i){return _c('span',{staticClass:"icon-star"})})),_c('p',{staticClass:"copy",domProps:{"innerHTML":_vm._s(review.copy)}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UjVH":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "UysK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VUTr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W2iy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LucreLogo_vue__ = __webpack_require__("g4s5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ea78449_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LucreLogo_vue__ = __webpack_require__("sawm");
function injectStyle (ssrContext) {
  __webpack_require__("ueqP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LucreLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ea78449_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LucreLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XZAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-spinning-cube",class:{ ready: _vm.ready }},[_c('div',{staticClass:"cube-container"},[_c('div',{staticClass:"cube animate"},[(_vm.$parent.ready)?_c('div'):_vm._e(),(_vm.$parent.ready)?_c('div'):_vm._e(),(_vm.$parent.ready)?_c('div'):_vm._e(),(_vm.$parent.ready)?_c('div'):_vm._e(),(_vm.$parent.ready)?_c('div'):_vm._e(),(_vm.$parent.ready)?_c('div'):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_routes__ = __webpack_require__("abeU");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_2__router_routes__["a" /* default */],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),

/***/ "Zhfs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Marquee__ = __webpack_require__("2Dd9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GameCards__ = __webpack_require__("E0n6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reviews__ = __webpack_require__("hr/h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Footer__ = __webpack_require__("TVmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Laurels__ = __webpack_require__("Lh/U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
var $win, metaMixin;

metaMixin = __webpack_require__("NpH0");















$win = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home-page',
  mixins: [metaMixin],
  components: {
    marquee: __WEBPACK_IMPORTED_MODULE_0__components_Marquee__["a" /* default */],
    'game-cards': __WEBPACK_IMPORTED_MODULE_1__components_GameCards__["a" /* default */],
    laurels: __WEBPACK_IMPORTED_MODULE_4__components_Laurels__["a" /* default */],
    reviews: __WEBPACK_IMPORTED_MODULE_2__components_Reviews__["a" /* default */],
    'lucre-footer': __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
  },
  data: function() {
    return {
      activeGradient: 0,
      meta: {
        title: 'GeoTap Game for iOS and Android',
        description: 'A subtly addictive stress-relief game',
        image: 'http://geotapgame.com/static/geotap-game-lucre-games-lowpoly-3d-casual-relaxing-mobile-game.png',
        route: '/'
      },
      unlockableImg: __webpack_require__("Nb4G")
    };
  },
  watch: {
    '$parent.ready': function(nv, ov) {
      return this.onScroll();
    }
  },
  mounted: function() {
    this.gradientAreas = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).find('.gradient-area');
    return $win.on('scroll', Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["throttle"])(this.onScroll, 50));
  },
  destroyed: function() {
    return $win.off('scroll');
  },
  methods: {
    onScroll: function(e) {
      var g, i, j, len, pos, ref;
      pos = $win.scrollTop() + ($win.outerHeight() * .7);
      ref = this.gradientAreas.get().reverse();
      for (j = 0, len = ref.length; j < len; j++) {
        g = ref[j];
        i = this.gradientAreas.index(g);
        if (pos >= __WEBPACK_IMPORTED_MODULE_6_jquery___default()(g).offset().top) {
          this.activeGradient = i;
          return false;
        }
      }
      // Defualt to the first gradient as a backup
      return this.activeGradient = 0;
    }
  }
});


/***/ }),

/***/ "aasZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page home-page"},[_c('div',{staticClass:"gradient-area"}),_c('marquee'),_c('game-cards'),_c('laurels'),_c('reviews'),_c('div',{staticClass:"gradient-area"}),_c('div',{staticClass:"unlockables"},[_c('img',{attrs:{"src":_vm.unlockableImg}})]),_c('div',{staticClass:"gradient-area"}),_c('lucre-footer'),_c('div',{staticClass:"gradient-backgrounds"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeGradient == 0),expression:"activeGradient == 0"}],staticClass:"gradient purple"})]),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeGradient == 1),expression:"activeGradient == 1"}],staticClass:"gradient blue",staticStyle:{"display":"none"}})]),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeGradient == 2),expression:"activeGradient == 2"}],staticClass:"gradient orange",staticStyle:{"display":"none"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "abeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home__ = __webpack_require__("HXef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_PressKit__ = __webpack_require__("FyeP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Privacy__ = __webpack_require__("fe4i");
var routes;







routes = [
  {
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Home__["a" /* default */]
  },
  {
    path: '/presskit',
    name: 'PressKit',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_PressKit__["a" /* default */]
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Privacy__["a" /* default */]
  },
  {
    // 404 Catch all
    path: '*',
    redirect: '/'
  }
];

// // Build route list for prerendering 
// const routes = require('../src/router/routes.coffee')
// let flatMap = require('lodash.flatMap')
// let pull = require('lodash.pull')

// prerenderRoutes = pull(flatMap(routes, 'path'), '*')
/* harmony default export */ __webpack_exports__["a"] = (routes);


/***/ }),

/***/ "acrx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cX1j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}]})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dZ18":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-1.159e7e0.png";

/***/ }),

/***/ "df1Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var site;

site = __webpack_require__("PaZl");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'store-links',
  data: function() {
    return {
      playStore: {
        image: __webpack_require__("C+62"),
        url: site.game.playStoreUrl
      },
      appStore: {
        image: __webpack_require__("knKY"),
        url: site.game.appStoreUrl
      }
    };
  }
});


/***/ }),

/***/ "fHJi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-social-links"},[_c('ul',_vm._l((_vm.links),function(link){return _c('li',[_c('a',{class:'icon-'+link.icon,attrs:{"href":link.url,"target":"_blank","data-gtm":"Social Links > Click","data-gtm-value":link.icon}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fe4i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__ = __webpack_require__("pq/i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e105b3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__("+Y5U");
function injectStyle (ssrContext) {
  __webpack_require__("UysK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e105b3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ffyJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lucre-games-indie-game-sacramento-logo-white.5825310.png";

/***/ }),

/***/ "g1j8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g4s5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lucre-logo',

  data: function data() {
    return { logo: __webpack_require__("ffyJ") };
  }
});

/***/ }),

/***/ "hN/e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'social-links',

  props: ['links']
});

/***/ }),

/***/ "hr/h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reviews_vue__ = __webpack_require__("s1Gn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208d5ba8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Reviews_vue__ = __webpack_require__("UIE5");
function injectStyle (ssrContext) {
  __webpack_require__("wH3X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reviews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208d5ba8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Reviews_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j7wJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jG5w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-3.99a6fd8.png";

/***/ }),

/***/ "jMLb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-footer"},[_c('geotap-logo',{attrs:{"heading":"h4"}}),_c('store-links'),_c('nav',{staticClass:"footer"},[_c('div',[_c('router-link',{attrs:{"to":"presskit"}},[_vm._v("Press kit ")])],1),_c('div',[_c('router-link',{attrs:{"to":"privacy"}},[_vm._v("Privacy ")])],1)]),_c('lucre-logo'),_c('social-links',{attrs:{"links":_vm.socialLinks}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kFtB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-store-links"},[_c('h3',[_vm._v("Play for free on Android and iOS")]),_c('a',{attrs:{"href":_vm.playStore.url,"data-gtm":"App Store Links > Click","data-gtm-value":"Play Store"}},[_c('img',{attrs:{"src":_vm.playStore.image}})]),_c('a',{attrs:{"href":_vm.appStore.url,"data-gtm":"App Store Links > Click","data-gtm-value":"App Store"}},[_c('img',{attrs:{"src":_vm.appStore.image}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kfK6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-indie-prize-finalist.ddc133c.png";

/***/ }),

/***/ "knKY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lucre-games-app-store-icon.9bc2018.png";

/***/ }),

/***/ "nr35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-laurels"},[_c('div',{staticClass:"laurels"},_vm._l((_vm.laurels),function(laurel){return _c('img',{attrs:{"src":laurel}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p8EQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pq/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GeotapLogo__ = __webpack_require__("2hiU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__("TVmP");
var metaMixin;

metaMixin = __webpack_require__("NpH0");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'privacy-page',
  mixins: [metaMixin],
  components: {
    'geotap-logo': __WEBPACK_IMPORTED_MODULE_0__components_GeotapLogo__["a" /* default */],
    'lucre-footer': __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */]
  },
  data: function() {
    return {
      meta: {
        title: 'Privacy Policy for GeoTap Game',
        description: '',
        image: 'http://geotapgame.com/static/geotap-game-lucre-games-lowpoly-3d-casual-relaxing-mobile-game.png',
        route: '/privacy'
      }
    };
  }
});


/***/ }),

/***/ "qSkX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r6Sm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-play-store-feature.3f3f2c3.png";

/***/ }),

/***/ "rC6c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GeotapLogo__ = __webpack_require__("2hiU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__("TVmP");
var metaMixin;

metaMixin = __webpack_require__("NpH0");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'presskit-page',
  mixins: [metaMixin],
  components: {
    'geotap-logo': __WEBPACK_IMPORTED_MODULE_0__components_GeotapLogo__["a" /* default */],
    'lucre-footer': __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */]
  },
  data: function() {
    return {
      meta: {
        title: 'Presskit for GeoTap by Lucre Games',
        description: 'Geotap is Lucre Games’ first mobile launch and was thought to be simple a exercise in shipping a title with the goal creating a platform to launch games with emotionally rich experiences that ride a fine line between pure art experiences and traditional game play.',
        image: 'http://geotapgame.com/static/geotap-game-lucre-games-lowpoly-3d-casual-relaxing-mobile-game-press-kit.png',
        route: '/presskit'
      },
      promo: [__webpack_require__("dZ18"), __webpack_require__("xn4w"), __webpack_require__("jG5w"), __webpack_require__("TOHJ"), __webpack_require__("R+Vo")],
      logos: [__webpack_require__("L2fN"), __webpack_require__("UjVH")]
    };
  }
});


/***/ }),

/***/ "s1Gn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reviews',
  data: function() {
    return {
      reviews: [
        {
          title: "Simple to play, hard to master!",
          stars: 5,
          copy: "Was turned on to this game from a friend and it’s great! Super easy to play but very challenging and fun… I find myself laughing because I just can’t keep from wanting to go fast and patience is definitely your friend with this game. Great job!"
        },
        {
          title: "Hypnotic, engaging and challenging!",
          stars: 5,
          copy: "An elegant blend of art and challenge, the game will work your brain, while exercising your need to fidget&mdash;all while providing and ambient soundtrack that you can somewhat control. Very nice."
        },
        {
          title: "Simple, easy, excellent.",
          stars: 5,
          copy: "This game makes me happy to open it. The sound and colors are all thought out well and the gameplay is relaxing and or challenging. It’s a great little game when I have time to kill."
        },
        {
          title: "Fantastic for all ages.",
          stars: 5,
          copy: "I wasn’t too sure when I downloaded this game because it’s so simple but it’s strangely addictive. Even my kiddos enjoy it."
        }
      ]
    };
  }
});


/***/ }),

/***/ "s1s7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-marquee"},[_c('div',{staticClass:"v-center-content"},[_c('transition',{attrs:{"name":"latefade"}},[_c('geotap-logo',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],attrs:{"heading":"h1"}})],1),_c('transition',{attrs:{"name":"latefade"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}]},[_vm._v("A subtly addictive stress-relief game")])]),_c('spinning-cube'),_c('transition',{attrs:{"name":"laterfade"}},[_c('store-links',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}]})],1),_c('transition',{attrs:{"name":"laterfade"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],staticClass:"icon-keyboard_arrow_down",on:{"click":_vm.onDownArrowClick}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sRCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geotap-logo',
  props: ['heading']
});


/***/ }),

/***/ "sawm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-logo"},[_c('a',{attrs:{"href":"http://lucregames.com","target":"_blank","data-gtm":"Footer > Link > Click","data-gtm-value":"lucre games logo"}},[_c('visual',{attrs:{"image":_vm.logo,"load":"visible","offset":"200","alt":"Lucre Games Logo - Indie Game Developers in Sacramento"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tLzU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ueqP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wD4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page presskit-page"},[_c('router-link',{attrs:{"to":"/","data-gtm":"Presskit > Click","data-gtm-value":"GeoTap Logo"}},[_c('geotap-logo',{attrs:{"heading":"h1"}})],1),_c('h2',[_vm._v("Press Kit")]),_c('text-content',[_c('strong',[_vm._v("Description:")]),_c('p',[_vm._v("Geotap is Lucre Games’ first mobile launch and was thought to be simple a exercise in shipping a title with the goal creating a platform to launch games with emotionally rich experiences that ride a fine line between pure art experiences and traditional game play.")]),_c('p',[_c('span',[_vm._v("A detailed article on our design process and what we learned from shipping the v1.0 in 3 weeks: ")]),_c('a',{attrs:{"target":"_blank","href":"https://medium.com/@LucreGames/ship-a-mobile-game-in-3-weeks-go-f0f4391ff6c8"}},[_vm._v("[Read on Medium]")])]),_c('strong',[_vm._v("Trailer:"),_c('p',[_c('iframe',{staticStyle:{"max-width":"100%"},attrs:{"width":"250","height":250 / (400/712),"src":"https://www.youtube.com/embed/1o2nTO3U2vU?rel=0&amp;showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":"allowfullscreen"}})])]),_c('strong',[_vm._v("Features:")]),_c('ul',[_c('li',[_vm._v("3 play modes: Classic, Tranquil and Focus")]),_c('li',[_vm._v("Low pressure game play")]),_c('li',[_vm._v("Smoothing soundscape and colors")]),_c('li',[_vm._v("High score leaderboards")]),_c('li',[_vm._v("10 simple shapes + 30 unlockable shapes")]),_c('li',[_vm._v("Discover unique interactive shapes")]),_c('li',[_vm._v("Or just relax")])]),_c('strong',[_vm._v("Logo Images:")]),_c('p',[_c('img',{staticClass:"screen",attrs:{"src":_vm.logos[0]}}),_c('img',{staticClass:"screen",attrs:{"src":_vm.logos[1]}})]),_c('strong',[_vm._v("Promotion Screens:")]),_c('p',[_c('img',{staticClass:"screen",attrs:{"src":_vm.promo[0]}}),_c('img',{staticClass:"screen",attrs:{"src":_vm.promo[1]}}),_c('img',{staticClass:"screen",attrs:{"src":_vm.promo[2]}}),_c('img',{staticClass:"screen",attrs:{"src":_vm.promo[3]}}),_c('img',{staticClass:"screen",attrs:{"src":_vm.promo[4]}})]),_c('strong',[_vm._v("Developer:")]),_c('p',[_c('a',{attrs:{"href":"http://lucregames.com","target":"_blank","data-gtm":"Presskit > Click","data-gtm-value":"Lucre Games Site"}},[_vm._v("Lucre Games")])]),_c('p',[_vm._v("Sacramento, California")]),_c('strong',[_vm._v("Release History:")]),_c('p',[_c('span',[_vm._v("v3.0 - Apr 23, 2018 ")]),_c('b',[_vm._v("Coming soon! ")])]),_c('p',[_vm._v("v2.3 - Mar 8, 2018")]),_c('p',[_vm._v("v2.0 - Dec 7, 2017")]),_c('p',[_vm._v("v1.1 - Oct 30, 2017")]),_c('p',[_vm._v("v1.0 - Sep 19, 2017")]),_c('strong',[_vm._v("Platforms:")]),_c('p',[_c('a',{attrs:{"href":"https://itunes.apple.com/us/app/geotap-game/id1268346417?mt=8","data-gtm":"Presskit > Click","data-gtm-value":"App Store Listing"}},[_vm._v("iOS on App Store ")])]),_c('p',[_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.roundhouse.geotap","data-gtm":"Presskit > Click","data-gtm-value":"Play Store Listing"}},[_vm._v("Android on Play Store")])]),_c('strong',[_vm._v("Website:")]),_c('p',[_c('router-link',{attrs:{"to":"/","data-gtm":"Presskit > Click","data-gtm-value":"GeoTap Website"}},[_vm._v("www.geotapgame.com")])],1),_c('strong',[_vm._v("Regular Price:")]),_c('p',[_vm._v("Free to play + In App Purchase")]),_c('strong',[_vm._v("Press / Business contact:")]),_c('p',[_c('a',{attrs:{"href":"mailto:hello@lucregames.com","data-gtm":"Presskit > Click","data-gtm-value":"Lucre Games Email"}},[_vm._v("hello@lucregames.com")])]),_c('strong',[_vm._v("Social:")]),_c('p',[_c('span',[_vm._v("Twitter: ")]),_c('a',{attrs:{"href":"https://twitter.com/LucreGames","target":"_blank","data-gtm":"Presskit > Click","data-gtm-value":"Lucre Games Twitter"}},[_vm._v("twitter.com/LucreGames")])]),_c('p',[_c('span',[_vm._v("Facebook: ")]),_c('a',{attrs:{"href":"https://facebook.com/LucreGames","target":"_blank","data-gtm":"Presskit > Click","data-gtm-value":"Lucre Games Facebook"}},[_vm._v("facebook.com/LucreGames")])]),_c('p',[_c('span',[_vm._v("Itch.io: ")]),_c('a',{attrs:{"href":"https://LucreGames.itch.io","target":"_blank","data-gtm":"Presskit > Click","data-gtm-value":"Lucre Games Itch"}},[_vm._v("LucreGames.itch.io")])]),_c('p',[_c('span',[_vm._v("Dribble: ")]),_c('a',{attrs:{"href":"https://dribbble.com/LucreGames","target":"_blank","data-gtm":"Presskit > Click","data-gtm-value":"Lucre Games Dribbble"}},[_vm._v("dribbble.com/LucreGames")])]),_c('p',[_c('span',[_vm._v("Instagram: ")]),_c('a',{attrs:{"href":"https://instagram.com/LucreGames","target":"_blank","data-gtm":"Presskit > Click","data-gtm-value":"Lucre Games Instagram"}},[_vm._v("instagram.com/LucreGames")])])]),_c('lucre-footer'),_c('div',{staticClass:"gradient-area"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wH3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x4nf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-text-content"},[_c('div',{staticClass:"wysiwyg"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xn4w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-2.afdbac2.png";

/***/ }),

/***/ "ztKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'spinning-cube',
  data: function() {
    return {
      ready: false
    };
  },
  mounted: function() {
    return setTimeout(this.buildIn, 300);
  },
  methods: {
    buildIn: function() {
      return this.ready = true;
    }
  }
});


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.97887253399d2fb92a7f.js